import { Button } from "./Button";
import { CLOSING_CTA } from "@/content/home";

export function CtaBand() {
  return (
    <section className="px-6 py-20">
      <div className="bg-block relative mx-auto flex max-w-6xl flex-col items-center gap-5 overflow-hidden rounded-[2rem] px-6 py-20 text-center shadow-lift">
        {/* soft decorative orbs */}
        <span className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-white/10" aria-hidden="true" />
        <span className="pointer-events-none absolute -bottom-20 -left-10 h-56 w-56 rounded-full bg-white/10" aria-hidden="true" />
        <h2 className="max-w-2xl text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
          {CLOSING_CTA.title}
        </h2>
        <p className="max-w-xl text-lg text-white/85">{CLOSING_CTA.body}</p>
        <Button to={CLOSING_CTA.cta.to} variant="onblock" className="mt-2">
          {CLOSING_CTA.cta.label}
        </Button>
      </div>
    </section>
  );
}
